'use client';

import {
  type InsuranceGroup,
  type InsuranceProduct,
  InsuranceProvider,
  InsuranceSelectorProvider
} from '@coolblue-development/next-insurance/insurance-selector';
import { useSummaryStore } from '@features/add-to-cart-page/components/SummaryStore/';
import { mapInsuranceProductToSummaryItem } from '@features/add-to-cart-page/components/SummaryStore/SummaryStore.mappers';

type Props = {
  productId: number;
  insuranceGroups: InsuranceGroup[];
  provider: InsuranceProvider;
  children: React.ReactNode;
};

export function InsuranceSelectorConfiguredProvider({
  children,
  insuranceGroups,
  provider,
  productId
}: Props) {
  const { addItem, removeItem, mainProductShoppingCartItem } = useSummaryStore();

  function getSelectedInsuranceId() {
    if (!mainProductShoppingCartItem?.insurance) {
      return 'none';
    }

    if (mainProductShoppingCartItem.insurance.provider === InsuranceProvider.CoverGenius) {
      return mainProductShoppingCartItem?.insurance?.quoteId ?? 'none';
    }

    return mainProductShoppingCartItem.insurance.productId ?? 'none';
  }

  function getSelectedInsuranceSubItemId() {
    if (!mainProductShoppingCartItem?.insurance) {
      return undefined;
    }

    return mainProductShoppingCartItem.insurance.subItemId;
  }

  function onInsuranceAdded(insuranceProduct: InsuranceProduct) {
    addItem(mapInsuranceProductToSummaryItem(insuranceProduct));
  }

  return (
    <InsuranceSelectorProvider
      productId={productId}
      insuranceGroups={insuranceGroups}
      provider={provider}
      mainProductShoppingCartItemId={mainProductShoppingCartItem?.id}
      subFeature='add_to_cart_page'
      initialValues={{
        selectedInsuranceId: getSelectedInsuranceId(),
        selectedSubItemId: getSelectedInsuranceSubItemId()
      }}
      onInsuranceAdded={onInsuranceAdded}
      onInsuranceRemoved={removeItem}
    >
      {children}
    </InsuranceSelectorProvider>
  );
}
